// light.ts
import { lightPalette } from './light'

// تابعی که رنگ رو می‌گیره و پالت رو می‌سازه
export const getLightPalette = (primaryColor: string) => lightPalette(primaryColor)
